<template>
    <PopupWrapper
        title="請輸入您的群組名稱與密碼"
        close
        @close="$emit('close')"
        @confirm="onValidateGroup"
    >
        <SelectWrapper
            v-if="user && user.historyGroups.length"
            label="更改群組"
            :options="(user && user.historyGroups) || []"
            :init-selected="user && user.group"
            @change="onChange"
        />

        <div v-if="!switchGroupTo">
            <InputWrapper
                v-model="data[input.fieldName]"
                v-for="(input, i) in groupInputs"
                :key="`input${i}`"
                :ref="`input${i}`"
                :label="input.label"
                :placeholder="input.placeholder"
                :rules="input.rules"
            />
        </div>
        <template v-slot:extra-button>
            <round-btn
                v-if="user && user.group"
                shadow-color="rgba(171, 203, 216, 0.5)"
                background-color="#bbbbbb"
                color="#ffffff"
                font-size="1.8em"
                height="70px"
                width="80%"
                style="margin-bottom: 20px"
                @click="onLeave"
            >
                <div class="button-content">退出當前群組</div>
            </round-btn>
        </template>
    </PopupWrapper>
</template>

<script>
import { mapState } from 'vuex';
import PopupWrapper from '@/components/Wrapper/PopupWrapper.vue';
import InputWrapper from '@/components/Wrapper/InputWrapper.vue';
import SelectWrapper from '@/components/Wrapper/SelectWrapper.vue';
import Sdk from '@/sdk';

export default {
    components: { PopupWrapper, InputWrapper, SelectWrapper },
    data() {
        return {
            groupInputs: [
                {
                    label: '群組名稱',
                    fieldName: 'name',
                    placeholder: '請輸入名稱',
                    rules: {
                        required: true,
                    },
                },
                {
                    label: '群組密碼',
                    fieldName: 'password',
                    placeholder: '請輸入密碼',
                    rules: {
                        required: true,
                    },
                },
            ],
            data: {},
            switchGroupTo: undefined,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
        }),
    },
    methods: {
        async onValidateGroup() {
            if (this.switchGroupTo) {
                try {
                    await Sdk.changeGroup({
                        name: this.switchGroupTo,
                    });
                    this.$emit('close');
                } catch (e) {
                    console.log(e.message);
                }
            } else {
                try {
                    const LENGTH = this.groupInputs.length;
                    let VALIDATE = true;
                    for (let i = 0; i < LENGTH; i += 1) {
                        const REF = this.$refs[`input${i}`][0];
                        if (!REF.validate() && VALIDATE) VALIDATE = false;
                    }
                    if (VALIDATE) {
                        await Sdk.changeGroup({
                            name: this.data.name,
                            password: this.data.password,
                        });
                        this.$emit('close');
                    }
                } catch ({ response }) {
                    console.log(response);
                    alert(response.data.message);
                }
            }
        },
        onChange(val) {
            this.switchGroupTo = val;
        },
        async onLeave() {
            await Sdk.leaveGroup();
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.button-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
